// extracted by mini-css-extract-plugin
export default {"container":"About_container__WyRjw","left":"About_left__FTyJp","headerAr":"About_headerAr__zmQjF","about":"About_about__iivJb","right":"About_right__6TxDz"};